import TemplateCasesContainer from './TemplateCasesContainer';

export default TemplateCasesContainer;
